export default "/assets/images/pc-carbon.83a783988d083303.webp";